import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { createI18n, castToVueI18n } from 'vue-i18n-bridge' // Use i18n-bridge to support both vue 2 and composition API

import messagesCommonJa from './messages/ja/common.json'
import messagesTopJa from './messages/ja/top.json'
import messagesOtherJa from './messages/ja/other.json'
import messagesTermsJa from './messages/ja/terms.json'
import messagesPrivacyPolicyJa from './messages/ja/privacyPolicy.json'
import messagesFinancialintermediaryJa from './messages/ja/financialintermediary.json'
import messagesServicesJa from './messages/ja/services.json'
import messagesFaqJa from './messages/ja/faq.json'
import messagesAutoAddJa from './messages/ja/autoAdd.json'
import messagesNoticeJa from './messages/ja/notice.json'
import messagesMaintenanceJa from './messages/ja/maintenance.json'
import messagesTransactionJa from './messages/ja/transaction.json'
import messagesHistoryJa from './messages/ja/history.json'
import messagesCourseChartJa from './messages/ja/courseChart.json'
import messagesDetailsJa from './messages/ja/details.json'
import { LocaleMessages, LocaleMessagesAll } from '@/types'

const originalWarn = console.warn
console.warn = function(...args: any[]) {
  if (args.length > 0 && typeof args[0] === 'string' && args[0].toLowerCase().includes('vue-i18n')) {
    return;
  } else {
    originalWarn.apply(console, args)
  }
}

export const supportedLocales = ['ja']

// TODO: create util that automatically imports all messages
const messagesCommon: LocaleMessagesAll = {
  ja: messagesCommonJa,
}
const messagesTop: LocaleMessagesAll = {
  ja: messagesTopJa,
}
const messagesOther: LocaleMessagesAll = {
  ja: {
    ...messagesOtherJa,
    ...messagesTermsJa,
    ...messagesPrivacyPolicyJa,
    ...messagesFinancialintermediaryJa,
    ...messagesNoticeJa,
    ...messagesServicesJa,
    ...messagesFaqJa,
    ...messagesAutoAddJa,
  },
}
const messagesError: LocaleMessagesAll = {
  ja: {...messagesMaintenanceJa},
}
const messagesHistory: LocaleMessagesAll = {
  ja: messagesHistoryJa,
}
const messagesTransaction: LocaleMessagesAll = {
  ja: messagesTransactionJa,
}
const messagesCourseChart: LocaleMessagesAll = {
  ja: messagesCourseChartJa,
}
const messagesDetails: LocaleMessagesAll = {
  ja: messagesDetailsJa,
}

// Example: If prefix is common, keys become test -> common_test, hello -> common_hello, etc.
function addPrefixToKeys(messages: LocaleMessages, prefix: string) {
  const newMessages: LocaleMessages = {}

  Object.keys(messages).forEach((key) => {
    newMessages[prefix + '_' + key] = messages[key]
  })

  return newMessages
}

Vue.use(VueI18n, { bridge: true })

const messages: LocaleMessagesAll = {}

for (let i = 0; i < supportedLocales.length; i++) {
  const locale = supportedLocales[i]
  messages[locale] = {
    ...addPrefixToKeys(messagesCommon[locale], 'common'),
    ...addPrefixToKeys(messagesTop[locale], 'top'),
    ...addPrefixToKeys(messagesOther[locale], 'other'),
    ...addPrefixToKeys(messagesTransaction[locale], 'transaction'),
    ...addPrefixToKeys(messagesError[locale], 'error'),
    ...addPrefixToKeys(messagesHistory[locale], 'history'),
    ...addPrefixToKeys(messagesCourseChart[locale], 'courseChart'),
    ...addPrefixToKeys(messagesDetails[locale], 'details'),
    // add more files here.
  }
}

const i18n = castToVueI18n(
  createI18n(
    {
      legacy: false, //support composition API
      locale: 'ja',
      messages,
    },
    VueI18n,
  ),
)

Vue.use(i18n)

export default i18n
